<template>
  <div class="col-md-12">
    <div>
      <Search
        :choosedItem="scoreItem"
        :url="url"
        :title="$lang.searchCenter_execute_case_competency"
        :remove_item="removeItem"
        config="center_execute_case_competency"
        :toggleable="false"
        removeModalSize="xl"
        :visibleAdd="false"
        :allowEdit="false"
        :allowRemove="false"
        ref="search_center_execute_case_competency"
        :dynamicButtons="availableButtons"
        :disAllowFields="['candidate', 'assessor', 'is_enable', 'status']"
        :isOverlay="isEditingScore"
      >
        <template slot="addModal" slot-scope="search">
          <AddCenterExecuteCaseCompetency
            isModal
            @modal-end-up="search.close"
          />
        </template>

        <template slot="details">
          <!-- Score Section -->
          <CompetencyScore
            v-if="isEditingScore"
            @cancel="cancelEditing"
            @ok="okEditing"
            :center_execute_id="scoreItem.center_execute_id"
            :case_id="scoreItem.case_id"
            :competency_id="scoreItem.competency_id"
          />
        </template>
      </Search>

      <b-modal
        no-close-on-backdrop
        variant="primary"
        header-bg-variant="primary"
        content-class="border-primary"
        v-model="view_history_CenterExecuteCaseCompetency"
        size="xl"
        ok-only
        hide-footer
      >
        <Search
          :allowCardNoBody="false"
          v-if="historyUrl"
          :url="historyUrl"
          ref="history_centerExecuteCaseCompetency_search"
          :title="$lang.searchCenter_execute_case_competency"
          config="center_execute_case_competency"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="false"
          :allowEdit="false"
          :allowRemove="false"
          :visibleAdd="false"
          :allowOperate="false"
        />
      </b-modal>

      <Confirm
        :title="modalTitle"
        :description="message"
        v-model="confirmModal"
        :ok-title="$lang.yes"
        :cancel-title="$lang.no"
        @ok="ok"
        @cancel="cancel"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddCenterExecuteCaseCompetency from "./addCenterExecuteCaseCompetency";
import CompetencyScore from "./editCenterExecuteCaseCompetencyScore";
import Confirm from "@/components/base/confirm";

export default {
  components: {
    Search,
    AddCenterExecuteCaseCompetency,
    Confirm,
    CompetencyScore,
  },
  data() {
    return {
      isEditingScore: false,
      scoreItem: {},
      modalTitle: "",
      message: "",
      confirmModal: false,
      loadingItem: false,
      changingItem: null,
      status: null,
      url:
        this.$config.api_url +
        this.$config.kanoon.center_execute_case_competency
          .replace("{0}", this.$route.params.center_execute_id)
          .replace("{1}", this.$route.params.case_id) +
        "?is_enable=1",

      view_history_CenterExecuteCaseCompetency: false,
      historyUrl: "",
      buttons: [
        {
          id: 0,
          name: "scoring",
          click: this.scoring,
          status_not: [],
        },
        {
          id: 1,
          name: "viewHistory", //
          click: this.showCenterExecuteCaseCompetencyHistory,
          status_not: [],
        },
        // {
        //   id: 2,
        //   name: "confirm",
        //   click: this.confirmCompetency,
        //   status_not: [1]
        // },
        // {
        //   id: 3,
        //   name: "reject",
        //   click: this.pendingCompetency,
        //   status_not: [2]
        // }
      ],
    };
  },
  methods: {
    clearModal() {
      this.modalTitle = "";
      this.message = "";
      this.changingItem = null;
      this.status = null;
      this.confirmModal = false;
    },
    ok() {
      this.confirmedChangeItem();

      this.clearModal();
    },
    cancel() {
      this.clearModal();
    },
    pendingCompetency(item) {
      this.changingItem = item;
      this.status = 2;
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.change_status;
      this.confirmModal = true;
    },
    confirmCompetency(item) {
      this.changingItem = item;
      this.status = 1;
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.change_status;
      this.confirmModal = true;
    },
    availableButtons(item) {
      if (!item || item == {}) return [];
      return this.buttons.filter((x) => {
        return !x.status_not.includes(item.status_object.id);
      });
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    scoring(item) {
      this.isEditingScore = true;
      this.scoreItem = item;
    },
    confirmedChangeItem() {
      this.changeStatus();
    },
    notConfirmedChangeItem() {},
    removeItem(item) {
      this.removingItem = item;
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.remove_item;
      this.changeModal = true;
    },
    closeCenterExecuteCaseCompetencyHistory() {
      this.view_history_CenterExecuteCaseCompetency = false;
      this.$refs.history_centerExecuteCaseCompetency_search.getItems();
    },
    showCenterExecuteCaseCompetencyHistory(item) {
      this.view_history_CenterExecuteCaseCompetency = true;
    },
    changeStatus() {
      let payLoad = {
        status: this.status,
      };
      this.loadingItem = true;
      return this.$httpService
        .patch(
          this.$config.api_url +
            this.$config.kanoon.center_execute_case_competency
              .replace("{0}", this.$route.params.center_execute_id)
              .replace("{1}", this.$route.params.case_id) +
            "/" +
            this.changingItem.competency_id +
            "/state",
          payLoad
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.$refs.search_center_execute_case_competency.getItems();
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        })
        .finally(() => {
          this.loadingItem = true;
          this.$refs.history_centerExecuteCaseCompetency_search.getItems();
          this.clearModal();
        });
    },
    okEditing(edited) {
      this.isEditingScore = false;
      let item = this.$refs.search_center_execute_case_competency.items.find(
        (x) =>
          x.center_execute_id == this.scoreItem.center_execute_id &&
          x.case_id == this.scoreItem.case_id &&
          x.competency_id == this.scoreItem.competency_id
      );
      item.score = edited.score;
      item.description = edited.description;
      this.scoreItem = {};
    },
    cancelEditing() {
      this.isEditingScore = false;
      this.scoreItem = {};
    },
  },
  created() {
    this.historyUrl =
      this.$config.api_url +
      this.$config.kanoon.center_execute_case_competency
        .replace("{0}", this.$route.params.center_execute_id)
        .replace("{1}", this.$route.params.case_id) +
      "?is_enable=0";
  },
};
</script>
